import React, { useState, useEffect } from 'react';
import { getExistingCategories } from '../services/albumService';

const CategoryInput = ({ value, onChange, required = false }) => {
  const [categories, setCategories] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isCustomInput, setIsCustomInput] = useState(false);

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      const existingCategories = await getExistingCategories();
      setCategories(existingCategories);
    } catch (error) {
      console.error('Error loading categories:', error);
    }
  };

  const handleSelectCategory = (category) => {
    onChange({ target: { value: category } });
    setIsDropdownOpen(false);
    setIsCustomInput(false);
  };

  const handleCustomInput = () => {
    setIsCustomInput(true);
    setIsDropdownOpen(false);
    onChange({ target: { value: '' } });
  };

  const handleInputChange = (e) => {
    onChange(e);
  };

  const filteredCategories = categories.filter(category =>
    category.toLowerCase().includes(value.toLowerCase())
  );

  if (isCustomInput) {
    return (
      <div className="relative">
        <input
          type="text"
          value={value}
          onChange={handleInputChange}
          placeholder="Enter new category"
          required={required}
          className="w-full p-3 border border-text-dark/30 rounded text-base box-border focus:outline-none focus:border-accent focus:shadow-[0_0_0_2px_rgba(186,230,253,0.25)]"
        />
        <button
          type="button"
          onClick={() => {
            setIsCustomInput(false);
            onChange({ target: { value: '' } });
          }}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-text-dark/50 hover:text-text-dark text-sm"
        >
          Cancel
        </button>
      </div>
    );
  }

  return (
    <div className="relative">
      <div
        className="w-full p-3 border border-text-dark/30 rounded text-base box-border cursor-pointer focus-within:border-accent focus-within:shadow-[0_0_0_2px_rgba(186,230,253,0.25)] bg-white flex justify-between items-center"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        <span className={value ? "text-text-dark" : "text-text-dark/50"}>
          {value || "Select category or add new..."}
        </span>
        <span className="material-icons text-text-dark/50">
          {isDropdownOpen ? 'expand_less' : 'expand_more'}
        </span>
      </div>

      {isDropdownOpen && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded shadow-lg z-10 max-h-60 overflow-y-auto">
          {categories.length > 0 && (
            <>
              {filteredCategories.map((category) => (
                <div
                  key={category}
                  className="p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                  onClick={() => handleSelectCategory(category)}
                >
                  {category}
                </div>
              ))}
              {filteredCategories.length === 0 && value && (
                <div className="p-3 text-text-dark/50 italic">
                  No matching categories found
                </div>
              )}
              <div className="border-t border-gray-200" />
            </>
          )}
          <div
            className="p-3 hover:bg-accent/10 cursor-pointer text-accent font-medium flex items-center gap-2"
            onClick={handleCustomInput}
          >
            <span className="material-icons text-base">add</span>
            Add new category
          </div>
        </div>
      )}

      {/* Hidden input for form validation */}
      <input
        type="hidden"
        value={value}
        required={required}
      />
    </div>
  );
};

export default CategoryInput;